"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2905],{

/***/ 52905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ dynamic_grid_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/dynamic-grid/dynamic-grid-component.scss.js




var HEADER_LOGO_HORIZONTAL_PADDING = "".concat(constants/* default.HEADER_CONTENT_HORIZONTAL_PADDING */.Z.HEADER_CONTENT_HORIZONTAL_PADDING, "px");
var StyledDynamicGrid = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "el6ghld0"
})("display:flex;flex-direction:column;justify-content:center;align-items:center;margin:auto;background-color:", function(param) {
    var backgroundColor = param.backgroundColor;
    return colors/* default */.Z[backgroundColor];
}, ";border-radius:", function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius;
}, ";padding:", function(param) {
    var gridPadding = param.gridPadding;
    return gridPadding;
}, ";", function(param) {
    var alignToLogo = param.alignToLogo;
    return alignToLogo && "\n    max-width: ".concat(vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;\n    padding-left: ").concat(HEADER_LOGO_HORIZONTAL_PADDING, "px;\n    padding-right: ").concat(HEADER_LOGO_HORIZONTAL_PADDING, "px;\n  ");
}, "  .grid-container{display:grid;grid-template-columns:repeat(auto-fit,minmax(", function(param) {
    var minItemWidth = param.minItemWidth;
    return minItemWidth;
}, ",1fr));grid-auto-rows:min-content;grid-gap:", function(param) {
    var verticalGap = param.verticalGap;
    return verticalGap;
}, " ", function(param) {
    var horizontalGap = param.horizontalGap;
    return horizontalGap;
}, ";width:100%;}.grid-item{width:100%;height:100%;display:flex;justify-content:center;align-items:center;}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/dynamic-grid/default-props.js
/* harmony default export */ var default_props = ({
    gridPadding: "16px",
    horizontalGap: "16px",
    verticalGap: "16px",
    backgroundColor: "layout-background-color",
    borderRadius: "8px",
    contentType: null
});

// EXTERNAL MODULE: ./segments/desktop/core-components/title/consts.js
var consts = __webpack_require__(49929);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/dynamic-grid/components/asset-content-card/asset-content-card-component.scss.js



var MIN_WIDTH = "250px";
var MAX_WIDTH = "400px";
var DIVIDER_BORDER_THICKNESS = "1px";
var DIVIDER_BACKGROUND_COLOR = "grey";
var StyledAssetContentCard = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1b5m5j50"
})("display:flex;flex-direction:column;border-style:solid;border-radius:", function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius;
}, ";border-width:", function(param) {
    var borderThickness = param.borderThickness;
    return borderThickness;
}, ";border-color:", function(param) {
    var borderColor = param.borderColor;
    return colors/* default */.Z[borderColor];
}, ";padding:", function(param) {
    var cardPadding = param.cardPadding;
    return cardPadding;
}, ";width:fit-content;min-width:", function(param) {
    var minWidth = param.minWidth;
    return minWidth || MIN_WIDTH;
}, ";max-width:", function(param) {
    var maxWidth = param.maxWidth;
    return maxWidth || MAX_WIDTH;
}, ";flex-shrink:1;.asset-wrapper{margin-bottom:", function(param) {
    var assetBottomMargin = param.assetBottomMargin;
    return assetBottomMargin;
}, ";}.content-wrapper{padding:", function(param) {
    var contentPadding = param.contentPadding;
    return contentPadding;
}, ";}.title-wrapper{font-size:", function(param) {
    var titleFontSize = param.titleFontSize;
    return consts/* titleFontSizes */.mo[titleFontSize];
}, ";font-weight:", function(param) {
    var titleFontWeight = param.titleFontWeight;
    return titleFontWeight;
}, ";margin-bottom:", function(param) {
    var titleBottomMargin = param.titleBottomMargin;
    return titleBottomMargin;
}, ";}.pills-container{position:relative;overflow:hidden;}.pills-wrapper{display:flex;flex-wrap:wrap;gap:8px;position:relative;z-index:1;}.hover-button-wrapper{position:absolute;bottom:0;left:0;width:100%;height:100%;background-color:white;display:flex;align-items:flex-end;transform:translateY(100%);transition:transform 0.3s ease-in-out;z-index:2;padding:", function(param) {
    var buttonPadding = param.buttonPadding;
    return buttonPadding;
}, ";&::before{content:'';position:absolute;top:0;left:0;width:100%;height:", function(param) {
    var dividerConfig = param.dividerConfig;
    return (dividerConfig === null || dividerConfig === void 0 ? void 0 : dividerConfig.borderThickness) || DIVIDER_BORDER_THICKNESS;
}, ";background-color:", function(param) {
    var dividerConfig = param.dividerConfig;
    return (dividerConfig === null || dividerConfig === void 0 ? void 0 : dividerConfig.backgroundColor) ? colors/* default */.Z[dividerConfig.backgroundColor] : DIVIDER_BACKGROUND_COLOR;
}, ";transform:translateY(100%);transition:transform 0.3s ease-in-out;:hover{transform:translateY(0);}}}&:hover{.hover-button-wrapper{transform:translateY(0);}}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/dynamic-grid/components/asset-content-card/default-props.js
/* harmony default export */ var asset_content_card_default_props = ({
    asset: {
        asset: {
            image: {
                src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/asset/timeline-view.png"
            }
        }
    },
    title: "",
    titleFontSize: "16px",
    borderRadius: "8px",
    borderThickness: "1px",
    borderColor: "layout-border-color",
    cardPadding: "16px"
});

// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
;// CONCATENATED MODULE: ./components/core/pill/pill-component.scss.js


var StyledPillComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ebrin360"
})("display:inline-block;text-align:center;transition:background-color 0.3s ease,opacity 0.3s ease;border-style:solid;background-color:", function(props) {
    return colors/* default */.Z[props.backgroundColor];
}, ";border-width:", function(props) {
    return props.borderThickness;
}, ";border-color:", function(props) {
    return colors/* default */.Z[props.borderColor];
}, ";border-radius:", function(props) {
    return props.borderRadius;
}, ";color:", function(props) {
    return colors/* default */.Z[props.textColor];
}, ";font-size:", function(props) {
    return props.fontSize;
}, ";padding:", function(props) {
    return props.padding;
}, ";margin:", function(props) {
    return props.margin;
}, ";&:hover{opacity:", function(props) {
    return props.hoverOpacity;
}, ";}");

;// CONCATENATED MODULE: ./components/core/pill/pill-component.js



var PillComponent = function(param) {
    var label = param.label, backgroundColor = param.backgroundColor, borderColor = param.borderColor, borderThickness = param.borderThickness, borderRadius = param.borderRadius, textColor = param.textColor, fontSize = param.fontSize, padding = param.padding, margin = param.margin, hoverOpacity = param.hoverOpacity;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPillComponent, {
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderThickness: borderThickness,
        borderRadius: borderRadius,
        textColor: textColor,
        fontSize: fontSize,
        padding: padding,
        margin: margin,
        hoverOpacity: hoverOpacity,
        children: label
    });
};
/* harmony default export */ var pill_component = (PillComponent);

// EXTERNAL MODULE: ./segments/desktop/core-components/button/button.js + 17 modules
var button_button = __webpack_require__(11068);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/dynamic-grid/components/asset-content-card/asset-content-card-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}







var AssetContentCardComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(AssetContentCardComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(AssetContentCardComponent);
    function AssetContentCardComponent() {
        (0,_class_call_check/* default */.Z)(this, AssetContentCardComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(AssetContentCardComponent, [
        {
            key: "render",
            value: function render() {
                var renderContentType = function renderContentType(contentType) {
                    if (contentType) {
                        var type = contentType.type;
                        switch(type){
                            case "Pills":
                                var pills = contentType.pills;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pills-container",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pills-wrapper",
                                            children: pills === null || pills === void 0 ? void 0 : pills.map(function(pill, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(pill_component, _object_spread({}, pill), index);
                                            })
                                        }),
                                        (buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.buttonType) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "hover-button-wrapper",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, _object_spread({}, buttonConfig))
                                        })
                                    ]
                                });
                            default:
                                return null;
                        }
                    }
                };
                var _props = this.props, asset = _props.asset, title = _props.title, titleFontSize = _props.titleFontSize, titleFontWeight = _props.titleFontWeight, minWidth = _props.minWidth, maxWidth = _props.maxWidth, borderRadius = _props.borderRadius, borderThickness = _props.borderThickness, borderColor = _props.borderColor, cardPadding = _props.cardPadding, contentPadding = _props.contentPadding, assetBottomMargin = _props.assetBottomMargin, titleBottomMargin = _props.titleBottomMargin, contentType = _props.contentType, buttonPadding = _props.buttonPadding, buttonConfig = _props.buttonConfig, dividerConfig = _props.dividerConfig;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAssetContentCard, {
                    className: "asset-content-card-component",
                    borderRadius: borderRadius,
                    borderThickness: borderThickness,
                    borderColor: borderColor,
                    cardPadding: cardPadding,
                    titleFontSize: titleFontSize,
                    titleFontWeight: titleFontWeight,
                    contentPadding: contentPadding,
                    assetBottomMargin: assetBottomMargin,
                    titleBottomMargin: titleBottomMargin,
                    minWidth: minWidth,
                    maxWidth: maxWidth,
                    buttonPadding: buttonPadding,
                    dividerConfig: dividerConfig,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "asset-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread({}, asset))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "content-wrapper",
                            children: [
                                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "title-wrapper",
                                    children: title
                                }),
                                contentType && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "content-type-wrapper",
                                    children: renderContentType(contentType)
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return AssetContentCardComponent;
}(react.PureComponent);

AssetContentCardComponent.defaultProps = asset_content_card_default_props;

// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/dynamic-grid/grid-item-types.js
var grid_item_types = __webpack_require__(8244);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/dynamic-grid/dynamic-grid-component.js




function dynamic_grid_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function dynamic_grid_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            dynamic_grid_component_define_property(target, key, source[key]);
        });
    }
    return target;
}







var DynamicGridComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(DynamicGridComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(DynamicGridComponent);
    function DynamicGridComponent() {
        (0,_class_call_check/* default */.Z)(this, DynamicGridComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(DynamicGridComponent, [
        {
            key: "minItemWidth",
            get: function get() {
                var itemMinWidth = this.props.itemMinWidth;
                return itemMinWidth || grid_item_types/* DEFAULT_MIN_WIDTH */.Fe;
            }
        },
        {
            key: "renderGridItem",
            value: function renderGridItem(child, key) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid-item",
                    children: child
                }, key);
            }
        },
        {
            key: "renderGridItems",
            value: function renderGridItems(gridItems) {
                var _this = this;
                if (gridItems) {
                    var type = gridItems.type;
                    switch(type){
                        case grid_item_types/* GRID_ITEM_TYPES.ASSET_CONTENT_CARD */.qE.ASSET_CONTENT_CARD:
                            var _gridItems_cards;
                            return (_gridItems_cards = gridItems.cards) === null || _gridItems_cards === void 0 ? void 0 : _gridItems_cards.map(function(card, index) {
                                return _this.renderGridItem(/*#__PURE__*/ (0,jsx_runtime.jsx)(AssetContentCardComponent, dynamic_grid_component_object_spread({}, card)), index);
                            });
                        default:
                            return null;
                    }
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, gridPadding = _props.gridPadding, horizontalGap = _props.horizontalGap, verticalGap = _props.verticalGap, backgroundColor = _props.backgroundColor, borderRadius = _props.borderRadius, gridItems = _props.gridItems, alignToLogo = _props.alignToLogo;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDynamicGrid, {
                    className: "dynamic-grid-component",
                    gridPadding: gridPadding,
                    horizontalGap: horizontalGap,
                    verticalGap: verticalGap,
                    backgroundColor: backgroundColor,
                    borderRadius: borderRadius,
                    minItemWidth: this.minItemWidth,
                    alignToLogo: alignToLogo,
                    children: gridItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid-container",
                        children: this.renderGridItems(gridItems)
                    })
                });
            }
        }
    ]);
    return DynamicGridComponent;
}(react.PureComponent);
DynamicGridComponent.defaultProps = default_props;
/* harmony default export */ var dynamic_grid_component = ((0,generic_config_context/* withGenericConfig */.P)(DynamicGridComponent));


/***/ })

}]);